import { SanityColor } from '../../tools/sanity';

export type PictoColorMode = 'text' | 'light' | 'dark' | 'custom';

const PICTO_TONE_FILL: Record<'light' | 'dark', string> = {
  light: '#ffffff',
  dark: '#000000',
};

export const resolvePictoFill = (
  mode: PictoColorMode = 'text',
  textColor?: SanityColor,
  pictoColor?: SanityColor
): string | undefined => {
  switch (mode) {
    case 'light':
      return PICTO_TONE_FILL.light;
    case 'dark':
      return PICTO_TONE_FILL.dark;
    case 'custom':
      return pictoColor?.hex;
    case 'text':
    default:
      return textColor?.hex ?? 'currentColor';
  }
};

export const getPictoToneClass = (mode: PictoColorMode = 'text'): string | undefined => {
  if (mode === 'light') return 'PageButton__picto--light';
  if (mode === 'dark') return 'PageButton__picto--dark';
  return undefined;
};
